import { CaseStudy } from '../data/caseStudies';

interface CaseStudyCardProps {
  study: CaseStudy;
}

function CaseStudyCard({ study }: CaseStudyCardProps) {
  return (
    <article className="case-card">
      <div className="case-card-meta">
        <span className="case-card-industry">{study.industry}</span>
        {study.placeholder && (
          <span
            className="case-card-placeholder"
            title="Template copy — replace with a real engagement before launch"
          >
            Illustrative example
          </span>
        )}
      </div>
      <h3 className="case-card-title">{study.title}</h3>
      <dl className="case-card-body">
        <dt>The challenge</dt>
        <dd>{study.challenge}</dd>
        <dt>What we built</dt>
        <dd>{study.built}</dd>
      </dl>
      <div className="case-card-tools" aria-label="Tools used">
        {study.tools.map(tool => (
          <span className="case-card-tool" key={tool}>
            {tool}
          </span>
        ))}
      </div>
      <div className="case-card-result">
        <span className="case-card-result-label">Result</span>
        <span className="case-card-result-value">{study.result}</span>
      </div>
    </article>
  );
}

export default CaseStudyCard;
